<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="350px"
      transition="dialog-transition"
    >
      <v-sheet>
        <v-toolbar dark class="primary">
          <v-btn
            icon
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Cambiar contraseña</v-toolbar-title>
        </v-toolbar>
        <v-form
          ref="form"
          v-model="valid"      
        >
          <v-container>
            <v-text-field
              v-model="password"
              placeholder="Ingrese la contraseña actual"
              label="Contraseña actual"
              prepend-icon="mdi-key"
              :append-icon="passwordHide ? 'mdi-eye-off' : 'mdi-eye'"
              :type="passwordHide ? 'password': 'text'"
              color="primary"
              @click:append="passwordHide = !passwordHide"
            ></v-text-field>
            <v-text-field
              v-model="passwordNew"
              placeholder="Ingrese la contraseña nueva"
              label="Contraseña nueva"
              prepend-icon="mdi-key"
              :append-icon="passwordNewHide ? 'mdi-eye-off' : 'mdi-eye'"
              :type="passwordNewHide ? 'password': 'text'"
              color="primary"
              @click:append="passwordNewHide = !passwordNewHide"
            ></v-text-field>
            <v-text-field
              v-model="passwordConfirm"
              placeholder="Ingrese la contraseña nueva"
              label="Confirmar contraseña nueva"
              prepend-icon="mdi-key"
              :append-icon="passwordConfirmHide ? 'mdi-eye-off' : 'mdi-eye'"
              :type="passwordConfirmHide ? 'password': 'text'"
              color="primary"
              @click:append="passwordConfirmHide = !passwordConfirmHide"
            ></v-text-field>
            <v-footer>
              <v-btn
                :disabled="disabled || !$can('usuarios.password')"
                color="primary"
                @click="onSubmit"
                :loading="loading"
              >
                Actualizar
              </v-btn>
            </v-footer>
          </v-container>
        </v-form>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'PasswordComponent',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    selected: Boolean
  },
  data () {
    return {
      valid: false,
      password: null,
      passwordNew: null,
      passwordConfirm: null,
      loading: false,
      passwordHide: true,
      passwordNewHide: true,
      passwordConfirmHide: true,
    }
  },
  beforeDestroy () {
    this.password = null;
    this.passwordConfirm = null;
  },
  computed: {
    dialog: {
      get () {
        return this.selected
      },
      set (value) {
        this.$emit('change', value)
      }
    },
    disabled() {
      return !this.password || !this.passwordNew  || (this.passwordNew !== this.passwordConfirm);
    },
  },
  methods: {
    ...mapActions('Auth', ['onChangePassword']),
    onSubmit () {
      if (this.$refs.form.validate()) {
        const payload = {
          current_password: this.password,
          new_password: this.passwordNew,
          new_password_confirmation: this.passwordConfirm
        }
        this.onChangePassword(payload).then(response => {
          this.dialog = false
          this.password = null
          this.passwordNew = null
          this.passwordConfirm = null
        })
      }
    },
    onClose (event) {
      event.preventDefault()
      this.dialog = false
    }
  },
}
</script>
